import {toAbsoluteUrl} from "../../_metronic/_helpers"
import { 
    PersonCircle, 
    PersonBadge,
    Building,
    Eye, 
    PersonCheck, 
    BagCheck,
    Journal,
    Wallet,
    Person,
    Box,
    Collection,
    ArrowLeftRight,
    ShieldLock,
    CreditCard,
    CloudDownload,
    CaretDownFill,
    ArrowUp,
    ArrowDown,
    ArrowRepeat,
    Check,
    Receipt,
    Trash3,
    PencilSquare,
    ChevronLeft,
    ChevronRight,
    PostcardHeart,
    At,
    Paperclip,
    ThreeDots,
    Folder2,
    FileEarmarkSpreadsheet,
    FileEarmarkText,
    PassFill,
    StarFill,
    FolderX,
    FlagFill,
    QuestionCircleFill,
    Cpu
   
} from "react-bootstrap-icons"

export const AdminIcon = PersonCircle
export const TroveNextIcon = PersonBadge
export const CorporateAccountsIcon = Building
export const ViewIcon = Eye
export const KYCIcon = PersonCheck
export const OrderIcon = BagCheck
export const TransactionIcon = Journal
export const PaymentIcon = Wallet
export const PortfolioCreationIcon = Folder2
export const StalledTransactionIcon = FolderX
export const UserIcon = Person
export const InstrumentIcon = Box
export const ThemeIcon = Collection
export const ExchangeRateIcon = ArrowLeftRight
export const HoldingIcon = ShieldLock
export const CardIcon = CreditCard
export const SubscriptionIcon = Receipt
export const GiftCardIcon = PostcardHeart
export const SocialIcon = At
export const ReportIcon = FileEarmarkSpreadsheet
export const CommercialPaperIcon = FileEarmarkText
export const MaintenanceFeeIcon = PassFill
export const GemsIcon = StarFill
export const AppendIcon = Paperclip
export const DownloadIcon = CloudDownload
export const DropdownIcon = CaretDownFill
export const MoreIcon = ThreeDots
export const TrashIcon = Trash3
export const EditIcon = PencilSquare
export const UpIcon = ArrowUp
export const DownIcon = ArrowDown
export const BackIcon = ChevronLeft
export const ForwardIcon = ChevronRight
export const RefreshIcon = ArrowRepeat
export const CheckIcon = Check
export const CampaignIcon = FlagFill
export const SecurityQuestionIcon = QuestionCircleFill
export const AiWorkspaceIcon = Cpu
export const SearchIcon = ({size}) => <img src={toAbsoluteUrl("/media/svg/search.svg")} alt="Search Icon" height={size} width={size} className="img-fluid"/>
